import type { Supplier } from '@tandemone/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { extractErrorMessage } from '@/api/extract-error'
import { reportError } from '@/domains/observability'

import { setPublicProfile } from './api'
import { SUPPLIER_ME_QUERY_KEY } from './use-supplier-me'

export function useSetPublicProfile() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (enabled: boolean) => setPublicProfile(enabled),
    onSuccess: supplier => {
      queryClient.setQueryData<Supplier>(SUPPLIER_ME_QUERY_KEY, supplier)
    },
    onError: error => {
      reportError(error)
      toast.error(extractErrorMessage(error))
    }
  })
}
